    // ========================================
    // CALCULATEUR DE QUANTITÉS
    // ========================================
    
    // Densités des produits en tonnes métriques par mètre cube
    const productDensities = {
        "Sable MG112": 1.7,      // ton/m³
        "Sable A tamisé": 1.7,            // ton/m³
        "Sable B tamisé": 1.7,        // ton/m³
        "Sable brut": 1.7,        // ton/m³
        "Terre à gazon": 1.7        // ton/m³
    };

    // Fonction pour calculer la quantité
    function calculateQuantity() {
        // Obtenir les valeurs du formulaire
        const selectedProduct = $('#produits').val();
        const systeme = $('input[name="systeme"]:checked').val();
        const longueur = parseFloat($('#longueur').val()) || 0;
        const largeur = parseFloat($('#largeur').val()) || 0;
        const epaisseur = parseFloat($('#epaisseur').val()) || 0;

        // Valider qu'un produit valide a été sélectionné
        if (!selectedProduct || selectedProduct === "" || !productDensities[selectedProduct]) {
            $('#quantite').val('');
            updateButtonState();
            return;
        }

        // Valider que toutes les valeurs sont présentes
        if (longueur <= 0 || largeur <= 0 || epaisseur <= 0) {
            $('#quantite').val('');
            updateButtonState();
            return;
        }

        let volumeM3 = 0;

        if (systeme === 'metrique') {
            // Système métrique : longueur et largeur en mètres, épaisseur en centimètres
            // Convertir l'épaisseur de cm en mètres
            const epaisseurMeters = epaisseur / 100;
            volumeM3 = longueur * largeur * epaisseurMeters;
        } else if (systeme === 'imperial') {
            // Système impérial : longueur et largeur en pieds, épaisseur en pouces
            // Convertir tout en mètres cubes
            const longueurMeters = longueur * 0.3048; // pieds en mètres
            const largeurMeters = largeur * 0.3048;   // pieds en mètres
            const epaisseurMeters = epaisseur * 0.0254; // pouces en mètres
            volumeM3 = longueurMeters * largeurMeters * epaisseurMeters;
        }

        // Calculer les tonnes métriques
        const density = productDensities[selectedProduct];
        const tonnesMetriques = volumeM3 * density;

        // Afficher le résultat avec 2 décimales
        $('#quantite').val(tonnesMetriques.toFixed(2));
        
        // Mettre à jour l'état du bouton
        updateButtonState();
    }

    // Fonction pour mettre à jour l'état du bouton de commande
    function updateButtonState() {
        const selectedProduct = $('#produits').val();
        const quantite = $('#quantite').val();
        const $btnCommander = $('#btn-commander');

        // Vérifier si tous les champs nécessaires sont remplis
        if (selectedProduct && selectedProduct !== "" && quantite && parseFloat(quantite) > 0) {
            // Activer le bouton et mettre à jour le lien avec les paramètres GET
            $btnCommander.removeClass('disabled');
            const urlParams = new URLSearchParams({
                produit: selectedProduct,
                quantite: quantite
            });
            $btnCommander.attr('href', 'coordonnees.php?' + urlParams.toString());
        } else {
            // Désactiver le bouton
            $btnCommander.addClass('disabled');
            $btnCommander.attr('href', '#');
        }
    }

    // Mettre à jour les placeholders selon le système sélectionné
    function updatePlaceholders() {
        $('#longueur').attr('placeholder', 'Longueur/mètres');
        $('#largeur').attr('placeholder', 'Largeur/mètres');
        $('#epaisseur').attr('placeholder', 'Épaisseur/centimètres');
    }

    // Event listeners pour recalculer quand les valeurs changent
    $('#produits').on('change', calculateQuantity);
    $('#longueur, #largeur, #epaisseur').on('input', calculateQuantity);

    // Empêcher la navigation si le bouton est désactivé
    $('#btn-commander').on('click', function(e) {
        if ($(this).hasClass('disabled')) {
            e.preventDefault();
            return false;
        }
    });

    // Initialiser les placeholders et l'état du bouton au chargement de la page
    updatePlaceholders();
    updateButtonState();

    // ========================================
    // FIN CALCULATEUR
    // ========================================